var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.Sticker = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var Sticker = function Sticker(_ref) {
    var className = _ref.className,
        label = _ref.label,
        position = _ref.position,
        inversed = _ref.inversed,
        collapsed = _ref.collapsed;
    var classnames = ['next-sticker', className, "next-sticker--".concat(position)];

    if (inversed) {
      classnames.push('next-sticker--inversed');
    }

    if (!collapsed) {
      classnames.push('next-sticker--spaced');
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: classnames.join(' ')
    }, label);
  };

  Sticker.propTypes = {
    className: _propTypes.default.string,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
    position: _propTypes.default.oneOf(['top-left', 'top-right', 'center', 'bottom-left', 'bottom-right']),
    inversed: _propTypes.default.bool,
    collapsed: _propTypes.default.bool
  };
  Sticker.defaultProps = {
    className: '',
    position: 'top-right',
    inversed: false,
    collapsed: true
  };
  var _default = Sticker;
  _exports.default = _default;
});